import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    title: 'Auditoría',
    desc: 'Detectas las fugas de energía en tus cuatro aspectos fundamentales.'
  }, {
    title: 'Sincronización',
    desc: 'Aplicas los protocolos diarios para alinear tu biología con tus metas de riqueza.'
  }, {
    title: 'Expansión',
    desc: 'Ejecutas tu plan de libertad financiera desde un estado de alto rendimiento y paz interna.'
  }];
  return <section className="bg-brand-cream text-brand-dark py-24 px-6" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        <FadeIn data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center text-brand-dark" data-id="element-132">
            Cómo funciona el proceso
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-133">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-brand-gold/30 z-0" data-id="element-134"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10 text-center" data-id="element-135">
              <div className="w-24 h-24 mx-auto bg-brand-dark text-brand-gold rounded-full flex items-center justify-center text-3xl font-serif font-bold mb-6 border-4 border-brand-cream shadow-lg" data-id="element-136">
                {index + 1}
              </div>
              <h3 className="font-bold text-2xl mb-4 text-brand-green" data-id="element-137">
                {step.title}
              </h3>
              <p className="text-brand-dark/70 leading-relaxed font-light px-4" data-id="element-138">
                {step.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}